/**
 * @module components\ghInput\barcodeInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import InputBase from "../inputBase";
import { Prop, Watch } from 'vue-property-decorator';
import JsBarcode from "jsbarcode";

@Component
export default class BarcodeInput extends InputBase {
  private verify={dialog:false,error:''};

  mounted() {
    this.refresh();
  }

  @Watch("value")
  private refresh(){
    this.verify.dialog=false;
    let code=this.$refs.barcode as HTMLImageElement;
    let res=this.value===""?" ":this.value;
    try {
      JsBarcode(code,res,{
        displayValue:false
      }); 
    } catch (error) {
      this.verify.dialog=true;
      this.verify.error='数据类型有误，请确认!';
    }
  }
}
